import {
    apiGet,
    apiGetAllPaginatedCollections
} from '../js/api';
import type {
    CustomRequestOptions
} from '../js/api';
import Server from '../js/config/_server';
import type { User } from './types';
import type { ResourceResponse, CollectionResponse } from './types/response';
import type { SearchParams } from './search';
import type { Dealership } from './types/index';
import { CLIENT_NAME } from '../js/config/_global';
import { CLIENT_LETTERS } from '../js/_constants';

export const getAllUserDealerships = options => {
    const url = Server.baseUrl + Server.services.users.userDealerships;
    return apiGetAllPaginatedCollections(url, options);
};

type Options = CustomRequestOptions & {
    params: Pick<SearchParams, 'page' |'query'>;
};

export const getUserDealerships = (options: Options) => {
    const url = Server.baseUrl + Server.services.users.userDealerships;
    return apiGet<CollectionResponse<Dealership>>(url, options);
};

export const getUser = () => {
    const url = Server.baseUrl + Server.services.users.me;
    return apiGet<ResourceResponse<User>>(url);
};

export const getDealerUploadRule = () => {
    const url = Server.baseUrl + Server.services.dealerUploadRule.get;
    return apiGet(url);
};

export const getDealershipGroup = (id) => {
    const url = Server.baseUrl + id;
    return apiGet(url);
};

export const getAllDealershipGroups = async (ids) => {
    const promises : any = [];
    let groupIds = []

    // if UI volkswagen, check if got access to dealershipGroups "V" and/or "N"
    if (CLIENT_NAME === 'volkswagen') {
        groupIds = ids.filter(id => id.split('/')[2] === CLIENT_LETTERS.volkswagen || id.split('/')[2] === CLIENT_LETTERS.nutzfahrzeuge);
    } else {
        groupIds = ids.filter(id => id.split('/')[2] === CLIENT_LETTERS[CLIENT_NAME]);
    }
   
    groupIds.forEach(id => promises.push(getDealershipGroup(id)));

    const result = await Promise.all(promises)

    return result;
};

export const user = {
    getDealerUploadRule,
    getAllDealershipGroups,
    getAllUserDealerships,
    getUserDealerships,
    getUser
};
